import api from '../../services/api';
import {
  GET_GOLDSMITH_PURCHASES_REQUEST,
  GET_GOLDSMITH_PURCHASES_SUCCESS,
  GET_GOLDSMITH_PURCHASES_FAILURE,
  GET_GOLDSMITH_PURCHASE_REQUEST,
  GET_GOLDSMITH_PURCHASE_SUCCESS,
  GET_GOLDSMITH_PURCHASE_FAILURE,
  CREATE_GOLDSMITH_PURCHASE_REQUEST,
  CREATE_GOLDSMITH_PURCHASE_SUCCESS,
  CREATE_GOLDSMITH_PURCHASE_FAILURE,
  UPDATE_GOLDSMITH_PURCHASE_REQUEST,
  UPDATE_GOLDSMITH_PURCHASE_SUCCESS,
  UPDATE_GOLDSMITH_PURCHASE_FAILURE,
  GET_TODAY_GOLD_RATE_REQUEST,
  GET_TODAY_GOLD_RATE_SUCCESS,
  GET_TODAY_GOLD_RATE_FAILURE,
  GET_PURCHASE_PAYMENTS_REQUEST,
  GET_PURCHASE_PAYMENTS_SUCCESS,
  GET_PURCHASE_PAYMENTS_FAILURE,
} from '../types';

// Get goldsmith purchases
export const getGoldsmithPurchases = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_GOLDSMITH_PURCHASES_REQUEST });
    
    const queryParams = new URLSearchParams();
    if (filters.goldsmithId) queryParams.append('goldsmith_id', filters.goldsmithId);
    if (filters.startDate) queryParams.append('start_date', filters.startDate);
    if (filters.endDate) queryParams.append('end_date', filters.endDate);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);
    
    const response = await api.get(`/goldsmith-purchases?${queryParams.toString()}`);
    
    dispatch({
      type: GET_GOLDSMITH_PURCHASES_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch goldsmith purchases';
    dispatch({
      type: GET_GOLDSMITH_PURCHASES_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get single goldsmith purchase
export const getGoldsmithPurchase = (purchaseId) => async (dispatch) => {
  try {
    dispatch({ type: GET_GOLDSMITH_PURCHASE_REQUEST });
    
    const response = await api.get(`/goldsmith-purchases/${purchaseId}`);
    
    dispatch({
      type: GET_GOLDSMITH_PURCHASE_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch goldsmith purchase';
    dispatch({
      type: GET_GOLDSMITH_PURCHASE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Create goldsmith purchase
export const createGoldsmithPurchase = (purchaseData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_GOLDSMITH_PURCHASE_REQUEST });
    
    const response = await api.post('/goldsmith-purchases', purchaseData);
    
    dispatch({
      type: CREATE_GOLDSMITH_PURCHASE_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create goldsmith purchase';
    dispatch({
      type: CREATE_GOLDSMITH_PURCHASE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Update goldsmith purchase
export const updateGoldsmithPurchase = (purchaseId, purchaseData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_GOLDSMITH_PURCHASE_REQUEST });
    
    const response = await api.put(`/goldsmith-purchases/${purchaseId}`, purchaseData);
    
    dispatch({
      type: UPDATE_GOLDSMITH_PURCHASE_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update goldsmith purchase';
    dispatch({
      type: UPDATE_GOLDSMITH_PURCHASE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get today's gold rate
export const getTodayGoldRate = () => async (dispatch) => {
  try {
    dispatch({ type: GET_TODAY_GOLD_RATE_REQUEST });
    
    const response = await api.get('/goldsmith-purchases/utils/gold-rate');
    
    dispatch({
      type: GET_TODAY_GOLD_RATE_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch gold rate';
    dispatch({
      type: GET_TODAY_GOLD_RATE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get purchase payments by payment mode
export const getPurchasePayments = (filters = {}) => async (dispatch) => {
  try {
    console.log('Dispatching GET_PURCHASE_PAYMENTS_REQUEST');
    dispatch({ type: GET_PURCHASE_PAYMENTS_REQUEST });
    
    const queryParams = new URLSearchParams();
    if (filters.paymentModeId) queryParams.append('paymentModeId', filters.paymentModeId);
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);
    
    const url = `/goldsmith-purchases/payments/list?${queryParams.toString()}`;
    console.log('Making API request to:', url);
    
    const response = await api.get(url);
    console.log('API response received:', response.data);
    
    dispatch({
      type: GET_PURCHASE_PAYMENTS_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    console.error('API error:', error);
    const message = error.response?.data?.message || 'Failed to fetch purchase payments';
    dispatch({
      type: GET_PURCHASE_PAYMENTS_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};
